export const environment = {
    production: false,
    SUPABASE_URL: 'https://hhqqlisayxhinnehipnc.supabase.co',
    SUPABASE_KEY: 'sb_publishable_K5uUhlWj0sBw8_ybDGSh4A_PKLcway0',
    API_URL: 'https://ts-gpu-02.walleye-climb.ts.net',

    SUPABASE_URL_IMAXINE: 'https://ckprspbmxurzwywfntse.supabase.co',
    SUPABASE_KEY_IMAXINE: 'sb_publishable_wDPZsvX6emPW4EEXKEyxAg_NHvM86Gu',
    ENCRYPTION_KEY: '66mG8oKeeG02wa5bkUjSneUiWwj_jtDDHkJuRh1sJ_c=', // Fernet key (32 bytes base64url) for license encryption/decryption
    COMPANY_NAME: 'ONE_MG',

    TATA_1MG_PPMC_CONFIG: {
        BASE_URL: 'https://jupiterppmc-api.1mg.com',
        WEBHOOK_URL: 'https://jupiterppmc-api.1mg.com/v2/external/api/tata-aia/digitization/center-visit',
        WEBHOOK_API_KEY: 'ppmc-imaxine-stag-jP_yA4lmt-xGuzfpJkqKe9zZe6TixKx47aF7BdHGZ18',
        ENCRYPTION_SECRET: '5htJTXF@H4Km9^@KeYD1*Yk2ZrFD#qm@T0-pl7B3sG%_TVCC',
        STORAGE_BUCKET: 'private',
        STORAGE_FOLDER: 'final_data',
        SIGNED_URL_EXPIRY_SECONDS: 7 * 24 * 60 * 60,
    },

};
